export enum SystemApiEnum {
  GetSystemInfo = '/system/info/',
  GetSystemSettings = '/system/settings/',
}
